import z from 'zod'
import { LanguageValidation } from '../../../../../../../src/shared/domain/Language'
import { MarketValidation } from '../../../../../../../src/shared/domain/Market'
import { SlugValidation } from '../../../../../../../src/_kernel/Slug'
import { ColorValidation } from '../../../../../../../src/_kernel/Color'
import { TitleValidation } from '../../../../../../../src/_kernel/Title'

export const GETCurrentPromoMarketingQuery = z.object({
  language: LanguageValidation.shape.value,
  market: MarketValidation.shape.value,
})

export type GETCurrentPromoMarketingResponse = z.infer<typeof GETCurrentPromoMarketingResponse>

export const GETCurrentPromoMarketingResponse = z
  .array(
    z.object({
      global: z.object({
        tags: z.object({
          color: ColorValidation.shape.value,
          background: ColorValidation.shape.value,
          text: TitleValidation.shape.value,
        }),
      }),
      slug: SlugValidation.shape.value,
    })
  )
  .nullable()
